<template>
  <v-dialog
      v-model="dialog"
      max-width="500"
    >
    <template v-slot:activator="{ on }">
      <v-btn
        color="lighten-2"
        v-on="on"
      >
        Change password
      </v-btn>
    </template>

    <v-card>
      <form method="post" @submit="changePassword">
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Change password
        </v-card-title>

        <v-card-text>
          <input type="hidden" name="username" :value="username">
          <v-text-field
            v-model="password1"
            label="Password"
            autocomplete="new-password"
            type="password"
            required
          ></v-text-field>
          <v-text-field
            v-model="password2"
            label="Confirm password"
            type="password"
            autocomplete="new-password"
            required
          ></v-text-field>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            @click="closeDialog"
          >
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :loading="loading"
            :disabled="password1 != password2"
            type="submit"
          >
            Change password
          </v-btn>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'ChangePassword',
  data () {
    return {
      password1: '',
      password2: '',
      dialog: false,
      loading: false
    }
  },
  computed: {
    ...mapState(['user']),
    ...mapGetters(['api']),
    username () {
      if (this.user) {
        return this.user.username
      }
      return ''
    }
  },
  methods: {
    changePassword (e) {
      e.preventDefault()
      this.loading = true
      this.$store.dispatch('changePassword', {
        'new_password1': this.password1,
        'new_password2': this.password2
      }).then(() => {
        this.loading = false
        this.dialog = false
      }).catch((err) => {
        alert(err.data.new_password2[0])
        this.loading = false
      })
    },
    closeDialog () {
      this.dialog = false
      this.password1 = ''
      this.password2 = ''
    }
  }
}
</script>
